import React from 'react';
export class CnListProItemTitle extends React.Component {
    render() {
        return <>{this.props.children}</>;
    }
}
CnListProItemTitle.displayName = 'CnListProItemTitle';
